import React from 'react';

export const DoubleColumnFormatter = (itemOnTop, itemOnButton) => {
  return (
    <>
      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
        {itemOnTop}
      </span>
      <span className="text-muted font-weight-bold">
        {itemOnButton}
      </span>
    </>
  );
};
